export default "__VITE_ASSET__CIDONWY0__"